// extracted by mini-css-extract-plugin
module.exports = {"container":"croppModal_container__28LqK","buttons":"croppModal_buttons__3Q8ol"};